import CompareIcon from '@/fo/icons/base/icons/compare.svg';
import DeleteIcon from '@/fo/icons/base/icons/delete.svg';

import { styles } from './UiProductCompareButton.styles';

export interface UiProductCompareButtonProps {
  onClick?: () => void;
  className?: string;
  isActive: boolean;
  onlyRemoveIcon?: boolean;
  loading?: boolean;
}

export function UiProductCompareButton({
  onClick,
  className,
  isActive,
  onlyRemoveIcon = false,
  loading = false
}: UiProductCompareButtonProps) {
  const slots = styles({ isActive, loading });

  return (
    <button
      onClick={onClick}
      type="button"
      className={slots.base({ className })}
      disabled={loading}
    >
      {loading && <span className={slots.loading()} />}
      {onlyRemoveIcon ? (
        <DeleteIcon
          className={slots.iconRemove({ className: 'h-full w-full' })}
        />
      ) : (
        <CompareIcon className={slots.icon({ className: 'h-full w-full' })} />
      )}
    </button>
  );
}
